import { Spin } from 'antd';

/** اسکلتون بارگذاری برای مسیرهای lazy */
const RouteFallback = () => (
  <div className="flex min-h-[50vh] items-center justify-center py-16">
    <Spin size="large" />
  </div>
);

export default RouteFallback;
